import { Injectable } from '@angular/core';

import "rxjs/add/operator/map"

import { AppSettings } from './app.setting';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Facturedetail } from '../entity/Facture';


@Injectable()
export class FacturedetailService {
    private baseUrl: string = environment.restApi + 'facturedetail';
    Facturedetails: Facturedetail[];

    constructor(private httpClient: HttpClient) {

    }



    getAll(): Observable<Facturedetail[]> {
        let Facturedetail$ = this.httpClient
            .get<Facturedetail[]>(this.baseUrl);
        return Facturedetail$;
    }



    findMaterielSpeci(): Observable<Facturedetail[]> {
        let Facturedetail$ = this.httpClient
            .get<Facturedetail[]>(this.baseUrl + '/findMaterielSpeci/1');
        return Facturedetail$;
    }

    findPublicite(): Observable<Facturedetail[]> {
        let Facturedetail$ = this.httpClient
            .get<Facturedetail[]>(this.baseUrl + '/findPublicite/1');
        return Facturedetail$;
    }




    private getHeaders() {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return headers;
    }


    create(Facturedetail: Facturedetail): Observable<Response> {
        return this.httpClient.post<Response>(`${this.baseUrl}`, JSON.stringify(Facturedetail));
    }
    save(Facturedetail: Facturedetail): Observable<Response> {

        return this.httpClient.put<Response>(`${this.baseUrl}/` + Facturedetail.idfacturedetail, JSON.stringify(Facturedetail));
    }
    private handleErrorPromise(error: Response | any) {
        console.error(error.message || error);
        return Promise.reject(error.message || error);
    }
}




